import { GraduationCap, Award, Stethoscope, Camera } from "lucide-react";
import { SectionHeading } from "./Section";
import { Stagger, StaggerItem } from "./Reveal";
import { SPECIALISTS } from "../data/site";

const initials = (name) => name.replace("Dr. ", "").split(" ").map((w) => w[0]).join("").slice(0, 2);

export const SpecialistCard = ({ s }) => (
  <div
    data-testid={`specialist-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
    className="group relative flex flex-col overflow-hidden rounded-[2rem] border border-dash-line bg-white shadow-[0_8px_30px_rgb(10,37,64,0.04)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_rgb(10,37,64,0.10)]"
  >
    {/* specialist photograph */}
    <div className="relative aspect-[4/3] overflow-hidden bg-gradient-to-br from-dash-ink via-dash-navy to-dash-indigo">
      {s.photo ? (
        <img
          src={s.photo}
          alt={s.name}
          loading="lazy"
          style={{ objectPosition: s.photoPos || "50% 20%" }}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      ) : (
        <>
          <div className="grain" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-display text-6xl font-bold text-white/90">{initials(s.name)}</span>
          </div>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 rounded-full bg-white/12 backdrop-blur px-3 py-1.5 text-[11px] text-white/80 border border-white/15">
            <Camera className="h-3.5 w-3.5" /> Photo to be added
          </div>
        </>
      )}
    </div>

    <div className="flex-1 p-7">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-dash-teal/10 px-3 py-1 text-xs font-semibold text-dash-teal">
        <Stethoscope className="h-3.5 w-3.5" /> {s.role}
      </span>
      <h3 className="mt-4 font-display text-2xl font-bold text-dash-ink">{s.name}</h3>

      <div className="mt-4 space-y-2.5">
        {s.qualification && (
          <div className="flex items-start gap-2.5 text-sm text-dash-muted">
            <GraduationCap className="h-4 w-4 shrink-0 text-dash-indigo mt-0.5" />
            <span>{s.qualification}</span>
          </div>
        )}
        {s.training && (
          <div className="flex items-start gap-2.5 text-sm text-dash-muted">
            <Award className="h-4 w-4 shrink-0 text-dash-gold mt-0.5" />
            <span>{s.training}</span>
          </div>
        )}
      </div>

      <p className="mt-5 text-sm leading-relaxed text-dash-muted">{s.desc}</p>
    </div>
  </div>
);

export const SpecialistsSection = () => (
  <section className="py-24 md:py-32 bg-dash-bg" data-testid="specialists-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading overline="Our Specialists" title="Meet Our Specialists" subtitle="Care delivered by qualified professionals dedicated to your wellbeing." />
      <Stagger className="mt-14 grid gap-8 md:grid-cols-2 max-w-4xl">
        {SPECIALISTS.map((s) => (
          <StaggerItem key={s.name}><SpecialistCard s={s} /></StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
